import styled from "styled-components";

export const TopicBox = styled.div`
  width: 100%;
  height: auto;
  text-align: center;
  position: relative;
  margin: 20px 0;
  @media (max-width: 767px) {
    margin: 20px 0;
  }
`;

export const PicBox = styled.img`
  width: 60vw;
  height: 5vw;
`;

export const TextBox = styled.div`
  font-family: promptLight;
  height: fit-content;
  width: 100%;
  text-align: center;
  font-size: 1.5vw;
  font-weight: bold;
  @media (max-width: 767px) {
    font-size: 20px;
    top: 0.1vw;
  }
  @media (max-width: 375px) {
    font-size: 20px;
    top: -2vw;
  }
  color: #0a2980;
  position: absolute;
  top: 1vw;
  z-index: 2;
`;

export const Cover = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`
export const TextBox2 = styled(TextBox)`
    font-family: cinzel;
    letter-spacing: 5px;
`